import './assets/main.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { createAppVuetify } from './plugins/vuetify'
import { mountLightningEmbed } from './embed/shadowMount'

const mountPoints = document.querySelectorAll('.lightning-model-page')

if (mountPoints.length > 0) {
  // WordPress / host-page embeds: mount inside Shadow DOM for style isolation.
  mountPoints.forEach(element => {
    mountLightningEmbed(element as HTMLElement)
  })
} else {
  // Standalone app (local dev / amplify preview).
  const app = createApp(App)
  app.use(createAppVuetify())
  app.use(router)
  app.use(createPinia())
  app.mount('#app')
}
